import axios from 'axios'
import CreateFaculty from './dto/CreateFaculty'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedFacultyResultRequestDto} from './dto/PagedFacultyResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllFaculties from './dto/GetAllFaculties'
import UpdateFaculty from './dto/UpdateFaculty'
import GetFaculty from './dto/GetFaculty'

const API_URL = process.env.REACT_APP_SERVICE_API_URL

export const URL_CREATE = `${API_URL}/Faculty/Create`
export const URL_DELETE = `${API_URL}/Faculty/Delete`
export const URL_GET = `${API_URL}/Faculty/Get`
export const URL_GET_ALL = `${API_URL}/Faculty/GetPagedAll`
export const URL_UPDATE = `${API_URL}/Faculty/Update`

export function onCreateFaculty(createFaculty: CreateFaculty): Promise<boolean> {
  return axios.post(URL_CREATE, createFaculty)
}

export function onDeleteFaculty(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetFaculty(entityDto: EntityDto): Promise<GetFaculty> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllFaculties(
  pagedFilterAndSortedRequest: PagedFacultyResultRequestDto
): Promise<PagedResultDto<GetAllFaculties>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateFaculty(updateFacultyInput: UpdateFaculty): Promise<boolean> {
  return axios.put(URL_UPDATE, updateFacultyInput)
}
